// Service definitions used by /services hub + each /services/<slug> page.

export const SERVICES = [
  {
    slug: "video-production",
    tag: "01",
    cover: "/generated/founder_cinema_camera.jpg",
    title: { fr: "Production vidéo", en: "Video production" },
    subtitle: {
      fr: "Films de marque, portraits de fondateurs, événements, témoignages, démos produits — montés pour durer.",
      en: "Brand films, founder stories, events, testimonials, product demos — cut to last.",
    },
    hero: {
      fr: "Le film qui transforme votre marque, pas une vidéo de plus.",
      en: "The film that transforms your brand, not just another video.",
    },
    intro: {
      fr: "Nous concevons et tournons des films cinématographiques pour les entreprises qui veulent être vues, retenues, et préférées. De la pré-production au montage final, tout est fait à l'interne par notre studio de Moncton.",
      en: "We design and shoot cinematic films for brands that want to be seen, remembered, and preferred. From pre-production to final cut, everything is handled in-house from our Moncton studio.",
    },
    deliverables: {
      fr: ["Film principal 60–120s", "3 capsules courtes 15s pour les réseaux", "Bande-son et étalonnage cinéma", "Cession des droits commerciaux complète"],
      en: ["Primary film 60–120s", "3 short cutdowns 15s for socials", "Sound design & cinema color grade", "Full commercial rights"],
    },
    use_cases: {
      fr: ["Lancement de produit", "Film de marque corporate", "Témoignage client", "Événement / conférence", "Documentaire court"],
      en: ["Product launch", "Corporate brand film", "Client testimonial", "Event / conference", "Short documentary"],
    },
    cta: { fr: "Démarrer un projet vidéo", en: "Start a video project" },
    seo_desc: {
      fr: "Production vidéo cinématique à Moncton, NB. Films de marque, témoignages clients, événements et drone aérien. Studio bilingue FR/EN basé à Moncton, devis sous 24h. Forfait Essentiel à partir de 1 800 $ CAD.",
      en: "Cinematic video production in Moncton, NB. Brand films, client testimonials, events and drone aerial. Bilingual FR/EN studio based in Moncton, 24-hour quotes. Essential package from CAD $1,800.",
    },
  },
  {
    slug: "photography",
    tag: "02",
    cover: "/generated/founder_photo_session.jpg",
    title: { fr: "Photographie", en: "Photography" },
    subtitle: {
      fr: "Portraits éditoriaux, équipes, espaces et produits — éclairés avec intention.",
      en: "Editorial portraits, teams, spaces and products — lit with intention.",
    },
    hero: {
      fr: "L'image fixe a encore quelque chose à dire — quand elle est bien faite.",
      en: "Still photography still has something to say — when it's done right.",
    },
    intro: {
      fr: "Une séance Phaneroo, c'est une direction artistique pensée, une lumière maîtrisée, et une retouche au service de votre marque. Nous photographions vos équipes, vos espaces, vos produits et vos événements.",
      en: "A Phaneroo session means deliberate art direction, controlled lighting, and retouching that serves your brand. We shoot teams, spaces, products and events.",
    },
    deliverables: {
      fr: ["20–40 images retouchées en haute résolution", "Versions web et impression", "Direction artistique incluse", "Licence usage illimité"],
      en: ["20–40 retouched high-res images", "Web + print exports", "Art direction included", "Unlimited usage license"],
    },
    use_cases: {
      fr: ["Portraits d'équipe", "Photographie produit", "Architecture et espaces", "Événements corporatifs", "Portraits éditoriaux"],
      en: ["Team portraits", "Product photography", "Architecture & spaces", "Corporate events", "Editorial portraits"],
    },
    cta: { fr: "Réserver une séance", en: "Book a session" },
    seo_desc: {
      fr: "Photographie cinématique éditoriale à Moncton, NB. Portraits d'équipe, photographie de marque personnelle, produits, architecture et événements corporatifs. Direction artistique premium incluse. Studio bilingue FR/EN.",
      en: "Cinematic editorial photography in Moncton, NB. Team portraits, personal brand photography, product, architecture and corporate events. Premium art direction included. Bilingual FR/EN studio.",
    },
  },
  {
    slug: "social-content",
    tag: "03",
    cover: "/generated/founder_director_monitor.jpg",
    title: { fr: "Contenu social", en: "Social content" },
    subtitle: {
      fr: "Réels, capsules verticales et systèmes d'épisodes pour Instagram, TikTok, LinkedIn et YouTube.",
      en: "Reels, vertical capsules and episode systems for Instagram, TikTok, LinkedIn and YouTube.",
    },
    hero: {
      fr: "Du contenu cinématographique. Au rythme des algorithmes.",
      en: "Cinematic content. Algorithm-ready.",
    },
    intro: {
      fr: "Nous produisons du contenu social qui ressemble à du cinéma, pas à de la publicité jetable. Forfaits mensuels ou ponctuels, avec stratégie éditoriale incluse.",
      en: "We produce social content that looks like cinema, not throwaway ads. Monthly retainers or one-off shoots, editorial strategy included.",
    },
    deliverables: {
      fr: ["8–16 capsules verticales / mois", "Sous-titres bilingues FR/EN", "Calendrier éditorial mensuel", "Rapport de performance"],
      en: ["8–16 vertical capsules / month", "Bilingual FR/EN captions", "Monthly editorial calendar", "Performance report"],
    },
    use_cases: {
      fr: ["Croissance Instagram & TikTok", "Personal branding fondateur", "Lancements produits", "Documentaires courts épisodiques"],
      en: ["Instagram & TikTok growth", "Founder personal branding", "Product launches", "Episodic short documentaries"],
    },
    cta: { fr: "Construire ma présence sociale", en: "Build my social presence" },
    seo_desc: {
      fr: "Création de contenu vidéo pour Instagram, TikTok, LinkedIn, YouTube. Bilingue FR/EN. Forfaits mensuels.",
      en: "Video content creation for Instagram, TikTok, LinkedIn, YouTube. Bilingual FR/EN. Monthly retainers.",
    },
  },
  {
    slug: "drone-aerial",
    tag: "04",
    cover: "/generated/founder_drone_outdoor.jpg",
    title: { fr: "Drone & aérien", en: "Drone & aerial" },
    subtitle: {
      fr: "Cinématographie aérienne au-dessus des paysages des Maritimes — pilote certifié RPAS.",
      en: "Aerial cinematography across the Maritimes — RPAS-certified pilot.",
    },
    hero: {
      fr: "Une autre échelle. Une autre histoire.",
      en: "Another scale. Another story.",
    },
    intro: {
      fr: "Pilote certifié RPAS Transport Canada. Nous tournons en 4K HDR au-dessus des côtes de Fundy, des routes du Nouveau-Brunswick, et des chantiers industriels. Sécurité et assurance commerciale comprises.",
      en: "Transport Canada RPAS-certified pilot. We shoot 4K HDR over the Fundy coast, New Brunswick highways, and industrial sites. Safety and commercial insurance included.",
    },
    deliverables: {
      fr: ["Tournage 4K HDR", "Étalonnage et stabilisation", "Plan de vol et autorisations", "Assurance commerciale 5M$"],
      en: ["4K HDR footage", "Grading & stabilization", "Flight plan & permits", "$5M commercial insurance"],
    },
    use_cases: {
      fr: ["Immobilier et hospitalité", "Industriel et construction", "Tourisme et nature", "Événements et mariages"],
      en: ["Real estate & hospitality", "Industrial & construction", "Tourism & nature", "Events & weddings"],
    },
    cta: { fr: "Réserver un vol", en: "Book a flight" },
    seo_desc: {
      fr: "Drone et cinématographie aérienne 4K HDR à Moncton, NB. Pilote RPAS certifié niveau avancé par Transports Canada. Assurance responsabilité commerciale 5 M$. Plan de vol, autorisations Nav Canada incluses. Canada Atlantique.",
      en: "Drone and 4K HDR aerial cinematography in Moncton, NB. Transport Canada Advanced RPAS-certified pilot. $5M commercial liability insurance. Flight plan and Nav Canada authorizations included. Atlantic Canada.",
    },
  },
  {
    slug: "art-direction",
    tag: "05",
    cover: "/generated/founder_black_bg_portrait.jpg",
    title: { fr: "Direction artistique", en: "Art direction" },
    subtitle: {
      fr: "Identité visuelle, direction photo, scénarisation et systèmes de marque cohérents.",
      en: "Visual identity, photo direction, scripting and consistent brand systems.",
    },
    hero: {
      fr: "Une marque, pas seulement un logo.",
      en: "A brand. Not just a logo.",
    },
    intro: {
      fr: "Avant de filmer, nous pensons. Direction artistique pour marques en lancement, repositionnement, ou besoin d'un univers visuel cohérent à travers vidéo, photo et social.",
      en: "Before filming, we think. Art direction for brands launching, repositioning, or needing a coherent visual universe across video, photo and social.",
    },
    deliverables: {
      fr: ["Manuel de marque visuelle", "Guides de tournage et de retouche", "Direction photo et scénarisation", "Templates motion et sociaux"],
      en: ["Visual brand book", "Shoot & retouch guidelines", "Photo direction & scripting", "Motion & social templates"],
    },
    use_cases: {
      fr: ["Lancement de marque", "Repositionnement", "Direction de campagne", "Système visuel cohérent multi-canal"],
      en: ["Brand launch", "Repositioning", "Campaign direction", "Coherent multi-channel visual system"],
    },
    cta: { fr: "Définir l'univers visuel", en: "Define the visual universe" },
    seo_desc: {
      fr: "Direction artistique et identité visuelle pour marques. Maritimes et Atlantique Canada. Bilingue FR/EN.",
      en: "Art direction and visual identity for brands. Maritimes and Atlantic Canada. Bilingual FR/EN.",
    },
  },
];

export function findService(slug) {
  return SERVICES.find((s) => s.slug === slug) || null;
}
